import * as React from 'react';
import i18n from 'i18next';
import MetaInfoService from '../../../services/MetaInfoService/MetaInfoService';
import { AnalyticsEngine } from '@sprinklr/stories/analytics/AnalyticsRequest';

export interface PickerStatus {
    valid: boolean;
    disabled: boolean;
    message: string;
}

// How many records to ask api for per-page
export const paginationCount = 50;

export abstract class Picker<P, S> extends React.Component<P, S> {
    protected getStatus(
        metaInfoService: MetaInfoService,
        engine: AnalyticsEngine,
        report: string,
        data?: Array<any>,
        loading?: boolean
    ): PickerStatus {
        const result = {
            valid: false,
            disabled: false,
            message: null,
        };

        result.valid = engine && report ? metaInfoService.isValidReport(engine, report) : true;
        result.disabled = !result.valid;

        if (!result.valid) {
            result.message = i18n.t('Select a metric first');
        } else {
            result.message = i18n.t('Select...');
        }

        return result;
    }
}
